import { browser } from '$app/environment';
import { Page } from '$lib/utils/page';
import { policy, policyExceptionHandler } from './-policy';
import { pageConditions } from './__config/conditions';

/** @type {import('@sveltejs/kit').Load} */
export async function load() {
	const metadata = {
		metaTag: [
			{
				content:
					"Create your ABCmouse account and start your family's early learning journey today.",
				name: 'description',
			},
			{
				content:
					"Create your ABCmouse account and start your family's early learning journey today.",
				property: 'og:description',
			},
			{
				content: 'ABCmouse | Create Your Account',
				property: 'og:title',
			},
			{
				content: 'https://www.abcmouse.com/abc/create-account/',
				property: 'og:url',
			},
		],
		schemaOrg: {
			graph: {
				webPage: {
					description:
						"Create your ABCmouse account and start your family's early learning journey today.",
					id: 'https://www.abcmouse.com/abc/create-account/#webpage',
					name: 'ABCmouse | Create Your Account',
					url: 'https://www.abcmouse.com/abc/create-account/',
				},
			},
		},
		title: 'ABCmouse | Create Your Account',
	};

	if (browser) {
		const page = new Page({
			conditions: pageConditions,
			metadata,
			policies: { policy, policyExceptionHandler },
			routePath: '/create-account',
		});

		return { page };
	}

	return { metadata };
}
